import React, { useEffect, useRef, useState } from 'react';
import { Button } from './ui/button';
import './PillNav.css';

const PillNav = ({ items, activeHref, onCTAClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const [introComplete, setIntroComplete] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    // Intro animation - start collapsed
    const timer = setTimeout(() => {
      setIntroComplete(true);
    }, 100);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      const sections = ['hero', 'about', 'how-we-work', 'skills', 'projects', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 150 && rect.bottom >= 150;
        }
        return false;
      });
      
      if (current) setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <nav 
        ref={navRef}
        className={`pill-nav-header ${isScrolled ? 'scrolled' : ''} ${introComplete ? 'intro-complete' : 'intro-start'}`}
      >
        <div className="pill-nav-container">
          {/* Logo */}
          <div 
            className="pill-logo-wrapper"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <div className="pill-logo-circle">
              <span className="pill-logo-text">RM</span>
            </div>
          </div>

          {/* Nav Items - Desktop */}
          <div className="pill-nav-items-wrapper">
            <ul className="pill-nav-list">
              {items.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className={`pill-nav-link ${activeSection === item.id ? 'active' : ''}`}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Button */}
          <Button 
            className="pill-nav-cta"
            onClick={onCTAClick}
          >
            Get Started
          </Button>

          {/* Mobile Menu Toggle */}
          <button 
            className="pill-mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="pill-mobile-menu">
          <ul className="pill-mobile-list">
            {items.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => scrollToSection(item.id)}
                  className="pill-mobile-link"
                >
                  {item.label}
                </button>
              </li>
            ))}
            <li>
              <Button 
                className="pill-mobile-cta"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  onCTAClick();
                }}
              >
                Get Started
              </Button>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default PillNav;